import axios from "axios";

const errorMessagesMap: { [key: string]: string } = {
  PasswordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
  PasswordRequiresNonAlphanumeric:
    "Le mot de passe doit contenir au moins un caractère spécial.",
  PasswordRequiresLower:
    "Le mot de passe doit contenir au moins une lettre minuscule.",
  PasswordRequiresUpper:
    "Le mot de passe doit contenir au moins une lettre majuscule.",
  InvalidEmail: "L'adresse e-mail est invalide.",
  EmailAlreadyExists: "Un compte existe déjà avec cette adresse e-mail.",
};
const register = async (
  email: string,
  password: string,
): Promise<string | true> => {
  const apiUrl = import.meta.env.VITE_API_URL;
  try {
    const response = await axios.post(`${apiUrl}/register`, {
      email,
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    }
  );
    if (response.status === 200) {
      localStorage.setItem("email", email);
      return true;
    }
  } catch (error: any) {
    if (error.response) {
      // console.error("API Error Response:", error.response);
      const { title, detail, errors } = error.response.data;

      let errorMessage = title || "Échec de l'enregistrement, veuillez réessayer.";

      if (detail) errorMessage += `: ${detail}`;
      if (errors) {
        for (const messages of Object.values(errors)) {
          if (Array.isArray(messages)) {
            const translatedMessages = messages
              .map((msg) => errorMessagesMap[msg] || msg)
              .join(", ");
            errorMessage += `\n${translatedMessages}`;
          }
        }
      }

      return errorMessage;
    } else {
      return "Une erreur inattendue est survenue.";
    }
  }
  return "Une erreur inconnue est survenue.";
};

export default register;
